export default __webpack_public_path__ + "static/media/1999.7e685e6e.png";